import React, { useCallback, useEffect, useState } from 'react'
import { BlockWrapper, defineBlock, useEditor } from '@smartfire/js-block-engine'
import style from './block.module.scss'
import { commonPostParams } from '../types'
import PostPageHeader from './Post'
import ContentPageHeader from './Content'
import { ReactComponent as Grooves } from './grooves.svg'
import { ReactComponent as GroovesPost } from './grooves_post.svg'
import { ReactComponent as GroovesMobile } from './grooves_mobile.svg'
import { BreadcrumbItemProps } from '../components/Breadcrumb'
import { useMediaQuery } from '../hooks'
import { CONSTS } from '../config/const'
import ErrorPageHeader from './404'

export type UpdatePageHeaderEventType = {
    title: string
    breadcrumb: BreadcrumbItemProps[]
}

type PageHeaderProps = {
    post: commonPostParams
    post_archive_url: string
    post_libelle: string
    title: string
    subTitle: string
    breadcrumb: BreadcrumbItemProps[]
    is404: boolean
    error_archive_url: string
    error_libelle: string
    none: boolean
}

const PageHeader: React.FC<PageHeaderProps> = ({
    post,
    post_archive_url,
    post_libelle,
    title,
    subTitle,
    breadcrumb,
    is404,
    error_libelle,
    none,
}) => {
    const { isEditing } = useEditor()
    const isMobile = useMediaQuery('(max-width: ' + style.mobileBreakpoint + ')')
    const [stateTitle, setStateTitle] = useState(title)
    const [stateBreadcrumb, setStateBreadcrumb] = useState(breadcrumb)

    const updatePageHeader = useCallback((event: CustomEvent<UpdatePageHeaderEventType>) => {
        if (event.detail.title) {
            setStateTitle(event.detail.title)
        }
        if (event.detail.breadcrumb) {
            setStateBreadcrumb(event.detail.breadcrumb)
        }
    }, [])

    useEffect(() => {
        window.addEventListener(CONSTS.UPDATE_PAGE_HEADER_EVENT_NAME, updatePageHeader)
        return () =>
            window.removeEventListener(CONSTS.UPDATE_PAGE_HEADER_EVENT_NAME, updatePageHeader)
    }, [updatePageHeader])

    if (none) {
        return <BlockWrapper.Without />
    }

    return (
        <BlockWrapper.Div className={style.block}>
            {isEditing && (
                <ContentPageHeader
                    title={'Page Header'}
                    subTitle={'Subtitle de Page Header'}
                    breadcrumb={[]}
                />
            )}
            {post && (
                <PostPageHeader post={post} archive_url={post_archive_url} libelle={post_libelle} />
            )}
            {title && (
                <ContentPageHeader
                    title={stateTitle}
                    subTitle={subTitle}
                    breadcrumb={stateBreadcrumb}
                />
            )}
            {is404 && <ErrorPageHeader libelle={error_libelle} />}

            {isMobile && <GroovesMobile className={style.grooves} />}
            {!isMobile && stateTitle && <Grooves className={style.grooves} />}
            {!isMobile && post && <GroovesPost className={style.grooves} />}
        </BlockWrapper.Div>
    )
}

export default defineBlock({
    Block: PageHeader,
    setup: {
        title: 'Page Header',
    },
})
